import { cn } from '@bazaar-marketplace/utils';
import type { FC } from 'react';

import type { BorderIconProps } from './types';
import { borderIconVariants } from './variants';

export const BorderIcon: FC<BorderIconProps> = ({ icon, className, variant, size, ...props }) => {
  if (variant === 'glass') {
    return (
      <div
        className={cn(
          'relative size-[56px] p-3 bg-white/10 backdrop-blur-[25px] rounded-full flex justify-center items-center',
          className,
        )}
        style={{
          border: '1px solid transparent',
          backgroundImage: `
            linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
            linear-gradient(137deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0) 55%, rgba(0, 0, 0, 0) 75%, rgba(255, 255, 255, 0.15) 100%)
          `,
          backgroundOrigin: 'border-box',
          backgroundClip: 'padding-box, border-box',
        }}
        {...props}
      >
        <div className="text-white size-6 flex items-center justify-center">{icon}</div>
      </div>
    );
  }

  return (
    <div className={cn(borderIconVariants({ variant, size }), className)} {...props}>
      {icon}
    </div>
  );
};
